import React from 'react';

import Box from '../Box';
import { Wrapper } from "./ACommonStyles"
import { getPcsUrls } from "./AHelpers"

export default props => {
    const aspectRatio = { mobile: 0.92, desktop: 1.67 }
    const aspectRatioSm = { mobile: 0.92, desktop: 0.52 }
    const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);

    return (
        <section className="container">
            <Wrapper className="row" pcs={pcs}>
                <div className="col-xs-12 col-md-9">
                    <Box {...props} id="b1" type="AImageSlider" settings={props.settings.b1} aspectRatio={aspectRatio} classes="" />
                </div>
                <div className="col-xs-12 col-md-3">
                    <Box {...props} id="b2" type="BTextOnPicture" size="sm" settings={props.settings.b2} aspectRatio={aspectRatioSm} classes="" />
                </div>
            </Wrapper>
        </section>
    );
}
